const flowTypes = {
  description: 'description',
  addContent: 'content',
  addSingleContent: 'content/:category',
  reviewFinish: 'review',
  success: 'success',
};

export default flowTypes;
